import { mediaUrl } from "@/lib/api";

export const AlpanaDivider = ({ className = "", color = "#C9A227" }) => (
  <div className={`flex items-center gap-3 ${className}`} aria-hidden="true" style={{ color }}>
    <span className="h-px flex-1 bg-gradient-to-r from-transparent to-current" />
    <svg width="72" height="24" viewBox="0 0 72 24" fill="none" stroke="currentColor" strokeWidth="1.2">
      <path d="M36 2 C40 7 40 17 36 22 C32 17 32 7 36 2Z" fill="currentColor" fillOpacity="0.25" />
      <path d="M25 12 C29 8 32 9 36 12 C32 15 29 16 25 12Z" />
      <path d="M47 12 C43 8 40 9 36 12 C40 15 43 16 47 12Z" />
      <circle cx="36" cy="12" r="2.2" fill="currentColor" />
      <circle cx="17" cy="12" r="1.6" fill="currentColor" />
      <circle cx="55" cy="12" r="1.6" fill="currentColor" />
      <circle cx="9" cy="12" r="1" fill="currentColor" />
      <circle cx="63" cy="12" r="1" fill="currentColor" />
    </svg>
    <span className="h-px flex-1 bg-gradient-to-l from-transparent to-current" />
  </div>
);

export const Logo = ({ url, size = 44, className = "" }) =>
  url ? (
    <img
      src={mediaUrl(url)}
      alt="TSS logo"
      data-testid="tss-logo"
      style={{ height: size, width: "auto" }}
      className={`rounded-md bg-white p-0.5 shadow-sm ${className}`}
    />
  ) : (
    <span
      data-testid="tss-logo"
      style={{ height: size, width: size }}
      className={`grid place-items-center rounded-md border-2 border-forest bg-white font-display text-sm font-extrabold text-maroon ${className}`}
    >
      TSS
    </span>
  );
